module.exports = __webpack_public_path__ + "img/nuovo_avviso.8c602c24.png";